<div class="invoice-preview" [class.dialog-mode]="isDialogMode">
  <div class="preview-shell">
    <div class="preview-header">
      <div class="header-copy">
        <p class="eyebrow">Debit Note</p>
        <div class="header-title-row">
          <h2>Finance Debit Note Preview</h2>
          <div class="toolbar" aria-label="Debit note actions">
            <mat-slide-toggle
              class="sign-toggle"
              color="primary"
              [checked]="includeSignature"
              (change)="onSignatureToggle($event.checked)">
              Sign + Stamp
            </mat-slide-toggle>
            <button mat-raised-button color="primary" (click)="printPdf()">
              Print
            </button>
            <button mat-stroked-button color="primary" (click)="downloadPdf()">
              Download PDF
            </button>
            <button mat-flat-button color="accent" (click)="sendMail()">
              Mail Debit Note
            </button>

            <button
              *ngIf="isDialogMode"
              mat-icon-button
              type="button"
              class="close-preview-button"
              aria-label="Close preview"
              (click)="closePreview()">
              <mat-icon svgIcon="mat:close"></mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="preview-frame" *ngIf="previewData; else loading">
      <div class="invoice-page">
        <div class="invoice-top-strip">
          <span></span>
          <span></span>
        </div>

        <div class="invoice-head">
          <div class="logo-cell">
            <img
              *ngIf="previewData.logo; else logoFallback"
              [src]="previewData.logo"
              alt="Company Logo" />
            <ng-template #logoFallback>
              <div class="logo-fallback">{{ previewData.companyInitials }}</div>
            </ng-template>
          </div>

          <div class="company-cell">
            <div class="document-kicker">Finance Department</div>
            <h1>{{ previewData.companyName | uppercase }}</h1>
            <p *ngIf="previewData.companyAddress">{{ previewData.companyAddress }}</p>
            <p *ngFor="let meta of previewData.companyMeta">{{ meta }}</p>
          </div>

          <div class="invoice-meta-box">
            <div class="meta-badge">DEBIT NOTE</div>
            <p><strong>Voucher No:</strong> {{ previewData.voucherNo }}</p>
            <p><strong>Voucher Date:</strong> {{ previewData.voucherDate }}</p>
            <p><strong>Reference No:</strong> {{ previewData.referenceNo }}</p>
            <p><strong>Reference Date:</strong> {{ previewData.referenceDate }}</p>
          </div>
        </div>

        <div class="po-overview">
          <div class="overview-card" *ngFor="let card of previewData.overview">
            <span class="overview-label">{{ card.label }}</span>
            <strong>{{ card.value }}</strong>
          </div>
        </div>

        <div class="two-col-info">
          <section class="section-block">
            <h3>Vendor Details</h3>
            <p class="info-primary">{{ previewData.vendorName }}</p>
            <p *ngIf="previewData.vendorAddress">{{ previewData.vendorAddress }}</p>
            <p *ngFor="let meta of previewData.vendorMeta">{{ meta }}</p>
          </section>

          <section class="section-block">
            <h3>Branch</h3>
            <p class="info-primary">{{ previewData.branchName }}</p>
          </section>
        </div>

        <div class="invoice-section" *ngFor="let invoice of previewData.invoiceRows">
          <div class="section-block invoice-summary-card">
            <h3>Invoice #: {{ invoice.billNo }}</h3>
            <div class="invoice-inline-meta">
              <span>Pending {{ invoice.payableAmount }}</span>
              <span>Debit {{ invoice.debitAmount }}</span>
              <span>Round Off {{ invoice.roundOffAmount }}</span>
            </div>
          </div>

          <div class="section-block" *ngIf="invoice.items.length">
            <table class="items-table compact-table">
              <thead>
                <tr>
                  <th>SR</th>
                  <th>ITEM</th>
                  <th>QTY</th>
                  <th>RATE</th>
                  <th>GROSS</th>
                  <th>TAX</th>
                  <th>NET</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let item of invoice.items">
                  <tr>
                    <td class="center">{{ item.sr }}</td>
                    <td>
                      <div>{{ item.productName }}</div>
                      <div class="item-remark secondary" *ngIf="item.taxSummary">
                        {{ item.taxSummary }}
                      </div>
                      <div class="item-remark secondary" *ngIf="item.remarks !== '-'">
                        Remarks: {{ item.remarks }}
                      </div>
                    </td>
                    <td class="right">{{ item.qty }}</td>
                    <td class="right">{{ item.rate }}</td>
                    <td class="right">{{ item.grossAmount }}</td>
                    <td class="right">{{ item.taxAmount }}</td>
                    <td class="right strong">{{ item.netAmount }}</td>
                  </tr>
                  <tr *ngIf="item.hasTaxes" class="tax-detail-row">
                    <td></td>
                    <td colspan="6">
                      <div class="tax-breakup-title">Tax Breakup</div>
                      <div class="tax-breakup-line" *ngFor="let tax of item.taxes">
                        {{ tax.taxName }} ({{ tax.taxRate | number: '1.0-2' }}%)
                        | Taxable {{ tax.taxableAmount }}
                        | Tax {{ tax.taxAmount }}
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <tr class="grand-row">
                  <td colspan="4" class="right">INVOICE TOTAL</td>
                  <td class="right">{{ invoice.totalGross }}</td>
                  <td class="right">{{ invoice.totalTax }}</td>
                  <td class="right">{{ invoice.totalNet }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="bottom-grid">
          <div class="details-block">
            <section class="words-block">
              <h3>Amount In Words</h3>
              <p>{{ previewData.amountInWords }}</p>
            </section>
            <section *ngIf="previewData.remarks !== '-'">
              <h3>Remarks</h3>
              <p>{{ previewData.remarks }}</p>
            </section>
          </div>

          <div class="summary-sign-block">
            <div class="html-sign-area">
              <div class="sign-company">
                For {{ previewData.companyNameTitle }}
              </div>
              <div class="sign-assets" *ngIf="includeSignature">
                <img
                  *ngIf="previewData.stampImage"
                  class="stamp-img"
                  [src]="previewData.stampImage"
                  alt="Company Stamp" />
                <img
                  *ngIf="previewData.signatureImage"
                  class="signature-img"
                  [src]="previewData.signatureImage"
                  alt="Signature" />
              </div>
              <div class="sign-name" *ngIf="previewData.signatoryName">
                {{ previewData.signatoryName }}
              </div>
              <div class="sign-role">
                {{ previewData.signatoryTitle || "Authorized Signatory" }}
              </div>
            </div>
          </div>
        </div>

        <div class="invoice-footer">
          <div class="footer-line">
            <span></span>
            <span></span>
          </div>
          <div class="footer-text">
            <span>Generated using VCS ERP</span>
            <span>Page 1 of 1</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <div class="loading-state">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p class="loading-text">
        {{
          includeSignature
            ? "Generating signed debit note preview..."
            : "Generating debit note preview..."
        }}
      </p>
    </div>
  </ng-template>
</div>
